module.exports = __webpack_public_path__ + "static/invertiry-8a33dde54a2d9cd99a1c99b96d5291e7.png";